import {Component} from 'react';
import {Translate} from 'react-redux-i18n';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {Notification} from 'front-onceforall-core';
import * as notificationsActions from '../../actions/notifications';
import {getNotificationData} from './NotificationData';
import notificationService from '../../services/notification/NotificationService';

export class NotificationDrawer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false
    };

    this.handleDismissNotification = this.handleDismissNotification.bind(this);
    this.getNewNotifications = this.getNewNotifications.bind(this);
  }

  componentDidMount() {
    this.getNewNotifications();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.getNewNotifications();
    }
  }

  getNewNotifications() {
    this.setState({error: false});
    this.props.actions.fetchNotifications(this.props.organisation)
      .catch(() => this.setState({error: true}));
  }

  handleDismissNotification(notificationId, notificationsLeft) {
    if (notificationsLeft === 1) {
      this.props.onHideDrawer();
    }

    this.props.actions.dismissNotification(notificationId);

    notificationService.dismiss(notificationId)
      .catch(() => this.getNewNotifications());
  }

  render() {
    const notificationsWithoutAction = this.props.notifications.informationNotifications.notifications
      .map(notification => {
        const {message, icon, action} = getNotificationData(notification);
        return (
          <Notification
            key={notification.notificationId}
            icon={icon}
            message={message}
            creationDate={notification.creationDate}
            onRemoveNotification={() => this.handleDismissNotification(notification.notificationId, notificationsWithoutAction.length)}
            onNotificationClick={() => {
              this.props.onNotificationClick(action);
              this.props.actions.setNotificationViewed(notification.notificationId);
            }}
            viewed={notification.viewed}
          />
        );
      });
    return (
      <div className={`notifications-drawer${this.props.show ? ' show' : ''}`}>
        {this.state.error && (
          <span><Translate value="error.generic"/></span>
        )}

        {!this.state.error && notificationsWithoutAction.length === 0 && (
          <div className="table-without-result">
            {this.props.notifications.isFetching &&
              <div className="loading-overlay"/>
            }
            <Translate value="notification.emptyList"/>
          </div>
        )}

        {!this.state.error && notificationsWithoutAction.length !== 0 && (
          <>{notificationsWithoutAction}</>
        )}
      </div>
    );
  }
}

NotificationDrawer.propTypes = {
  currentLocale: PropTypes.string.isRequired,
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  notifications: PropTypes.object.isRequired,
  show: PropTypes.bool,
  onNotificationClick: PropTypes.func.isRequired,
  onHideDrawer: PropTypes.func.isRequired
};

NotificationDrawer.defaultProps = {
  show: false
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    currentLocale: state.i18n.locale,
    notifications: state.notifications
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...notificationsActions}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationDrawer);
